import {
  businessPerformanceTabDoc,
  polyFinancialsTabNumber,
  scoreCardTabNumber,
} from 'legacy/lut/components/widgets/public/partner360/ELT/configs'

interface IGetLastStep {
  currentStep: number | undefined
  isPolyFinancialsStepExist?: boolean
  isHasPlcData?: boolean
  isBusinessPerformanceTabEnabled?: boolean
}
export const getLastStep = ({
  currentStep = 0,
  isPolyFinancialsStepExist,
  isHasPlcData,
  isBusinessPerformanceTabEnabled,
}: IGetLastStep) => {
  const finishStep = 9

  const nextStep = currentStep < finishStep ? currentStep + 1 : finishStep

  if (!isPolyFinancialsStepExist && nextStep === polyFinancialsTabNumber) {
    return nextStep + 1
  }
  if (!isHasPlcData && nextStep === scoreCardTabNumber) {
    return nextStep + 1
  }

  if (!isBusinessPerformanceTabEnabled && nextStep === businessPerformanceTabDoc) {
    return nextStep + 1
  }
  return nextStep
}

export const getLastGuideStep = (currentStep: number | undefined = 1) => {
  const finishStep = 2
  return currentStep < finishStep ? currentStep + 1 : finishStep
}
